import { setCookie, getCookie } from '../modules/_utils';

document.addEventListener("DOMContentLoaded", () => {

  function handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledPercent = (scrollTop / totalHeight) * 100;
  
    if (scrolledPercent >= 10) {
      console.log("User has scrolled 10% or more of the page.");
      window.removeEventListener('scroll',handleScroll);

      if ( !getCookie('ebookPopup') ){

        setCookie('ebookPopup', true);
        
        if ( document.getElementById("formWFAIBook") ) {
          document.getElementById("formWFAIBook").classList.add('is-active')

          const closeButtons = document.querySelectorAll(".modal-background, .modal-close");

          closeButtons.forEach((_el) => {
            const _target = _el.closest(".modal");
            
            _el.addEventListener("click", () => {
                _target.classList.remove("is-active");
            });
          });
          
        }// if modal element

      }


    } // if scrolled 10%
  }


  window.addEventListener("scroll", handleScroll);

  if ( getCookie('ebookPopup') ){
    window.removeEventListener('scroll',handleScroll);
  }



});// on load